import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component } from 'vue-property-decorator';

import { filter } from 'rxjs/operators';
import { keyboard$ } from '../keyboard';

@Component({
    props: ['eventFilterIdentifier']
})
export class BarcodeReader extends ReactiveVue {

    public eventFilterIdentifier: string;

    public created() {
        this.subscribeTo(keyboard$.pipe(
            filter(
                inputEvent => !this.eventFilterIdentifier ||
                    (inputEvent.inputEventIdentifier === this.eventFilterIdentifier)
            )
        ), input => {
            this.$emit('input', input.char);
        });
    }

    public render() {
        return null;
    }
}
